module.exports = "pegasus/assets/blocks/column-2-theme6.png";